import React, {Component} from "react";
import qs from "qs";
import algoliasearch from "algoliasearch/lite";
import {Configure, InstantSearch, ClearRefinements} from "react-instantsearch-dom";
import PartnerMessagePanel from "../../Components/PartnerContact/PartnerMessagePanel";
import PartnerFilterPan from "../../Components/PartnerContact/PartnerFilterPan";
import PartnerResultOptions from "../../Components/PartnerContact/PartnerResultOptions";
import CancelBtn from "../../Components/PartnerContact/CancelBtn";


const searchClient = algoliasearch(
    "6KMP52GB5X",
    "a4bb5f7de85b6dc3b2313ece00f93394"
);
const createURL = (state) => `?${qs.stringify(state)}`;
const DEBOUNCE_TIME = 700;
const DIRECTORY_INDEX = window.directory_index


const searchStateToUrl = (location, searchState) =>
    searchState ? `${location.pathname}${createURL(searchState)}` : "";

const urlToSearchState = (location) => qs.parse(location.search.slice(1));

export default class PartnerContact extends Component {
    constructor(props) {
        super(props);
        this.setStateId = React.createRef();
        this.state = {
            searchState: urlToSearchState(this.props.location),
            locationState: null,
            messageIsOpen: false,
            messageCancel: false,
        };
    }

    componentDidUpdate(prevProps) {
        // const nextSearchState = urlToSearchState(this.props.location);
        // if (
        //   JSON.stringify(this.state.searchState) !== JSON.stringify(nextSearchState)
        // ) {
        //   this.setState({ searchState: nextSearchState });
        // }
    }

    _onSearchStateChange = (nextSearchState) => {
        clearTimeout(this.setStateId.current);
        /*
        this.setStateId.current = setTimeout(() => {
            this.props.history.push(
                searchStateToUrl(this.props.location, nextSearchState),
                nextSearchState
            );
        }, DEBOUNCE_TIME);
        */

        this.setState({searchState: nextSearchState});
    };

    _onLocationStateSearch = (locationState) => {
        this.setState({locationState});
    };

    submitHandler(e) {
        e.preventDefault();
    }

    _onCancelMessage = () => {
        this.setState({messageIsOpen: false, messageCancel: true});
        setTimeout(() => this.setState({messageCancel: false}), 500);
    };


    render() {
        return (
            <InstantSearch
                searchClient={searchClient}
                //createURL={(searchState) => `?q=${searchState.query}`}
                indexName={DIRECTORY_INDEX}
                initialUiState={{
                    DIRECTORY_INDEX: {
                        facetFilters: [
                            [
                                "directory_user_type:Manufacturers+Suppliers"
                            ]
                        ],
                    },
                }}
                searchState={this.state.searchState}
                onSearchStateChange={this._onSearchStateChange}
            >
                <Configure
                    analytics={true}
                    filters={'directory_user_type:"Manufacturers Suppliers"'}
                    hitsPerPage={40}
                />
                <div className="main__body">
                    <div className="main__inner main__inner-results">
                        <section className="section-results">
                            <div className="shell shell--alt">
                                <div className="section__inner">
                                    <div className="form-search js-form-search filters-open js-filters-panel">
                                        <div className="form__head">
                                            <div className="form__row">
                                            </div>
                                        </div>
                                        <div className="form__body">
                                            <aside className="form__aside" style={{height: '100%'}}>
                                                <PartnerFilterPan messageIsOpen={this.state.messageIsOpen}/>
                                                <div className="partner-modal-btn"
                                                     style={{paddingTop: '20px', paddingBottom: '10px'}}>
                                                    {this.state.messageIsOpen ? (

                                                        /*<button onClick={() => this._onCancelMessage()}
                                                                className="btn btn--gray btn--outline">Cancel Message &
                                                            Return
                                                            Back
                                                        </button>*/
                                                        <CancelBtn onMessageCancel={() => this._onCancelMessage()}/>
                                                    ) : (
                                                        <button className="btn btn--outline"
                                                                onClick={() => this.setState({messageIsOpen: true})}>Contact
                                                            Manufacturers & Suppliers
                                                        </button>
                                                    )}
                                                < /div>
                                            </aside>
                                            <div className="form__content">
                                                <PartnerResultOptions
                                                    messageIsOpen={this.state.messageIsOpen}
                                                    onMessageSend={() => this.setState({messageIsOpen: false})}
                                                    onMessageClose={() => this.setState({messageIsOpen: false})}
                                                    onMessageOpen={() => this.setState({messageIsOpen: true})}
                                                    onMessageShow={this.state.messageIsOpen}
                                                    messageCancel={this.state.messageCancel}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </InstantSearch>
        );
    }
}
